<template>
  <div class="feature-icon-list improved-feature-list">
    <div class="row align-items-center">

      <div class="col-lg-6 mb-4 mb-lg-0">
        <div class="feature-icon-list__media wow move-up">
          <img src="../assets/img/features/img-quienes-somos.png" class="img-fluid"
            alt="Equipo Leonix creando soluciones a la medida" loading="lazy" decoding="async" />
        </div>
      </div>

      <div class="col-lg-6">
        <div class="feature-icon-list__content">

          <h2 class="section-title mb-4">Nuestra Propuesta de Valor</h2>

          <div class="feature-icon-list-wrapper">
            <div v-for="feature in features" :key="feature.id" class="single-feature-icon improved-card wow move-up">
              <div class="single-feature-icon__media">
                <img :src="feature.icon" class="img-fluid icon-size" :alt="feature.alt" loading="lazy"
                  decoding="async" />
              </div>

              <div class="single-feature-icon__content">
                <h6 class="title">{{ feature.title }}</h6>
                <p class="text">{{ feature.desc }}</p>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'FeatureList',
  data() {
    return {
      features: [
        {
          id: 'tech',
          icon: require('../assets/img/icons/aeroland-branding-box-image-01-1.png'),
          alt: 'Icono de tecnología',
          title: 'Tecnología que impulsa tu negocio',
          desc:
            'Desarrollamos software, aplicaciones y plataformas web que resuelven problemas reales, con arquitectura moderna pensada para escalar.',
        },
        {
          id: 'ux',
          icon: require('../assets/img/icons/aeroland-branding-box-image-02-1.png'),
          alt: 'Icono de experiencia de usuario',
          title: 'Diseño centrado en el usuario',
          desc:
            'Creamos interfaces claras, intuitivas y profesionales que mejoran la experiencia y fortalecen tu presencia digital.',
        },
        {
          id: 'innovation',
          icon: require('../assets/img/icons/aeroland-branding-box-image-03-1.png'),
          alt: 'Icono de innovación',
          title: 'Innovación aplicada y automatización',
          desc:
            'Optimizamos procesos con soluciones inteligentes basadas en datos, automatización e integración tecnológica.',
        },
      ],
    }
  },
}
</script>

<style scoped>
.improved-feature-list {
  padding-top: 40px;
}

.section-title {
  font-size: 32px;
  font-weight: 700;
  color: #1d1d1f;
}

.improved-card {
  display: flex;
  padding: 18px 20px;
  border-radius: 14px;
  background: #ffffff;
  margin-bottom: 20px;
  transition: all 0.25s ease;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.04);
}

.improved-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.09);
}

.icon-size {
  width: 52px;
  height: auto;
}

.single-feature-icon__content .title {
  font-size: 17px;
  margin-bottom: 4px;
}

.single-feature-icon__content .text {
  font-size: 13px;
  color: #444;
  text-align: left;
}
</style>
